<template>
   <pb-body-base :busy="busy">
      <template v-slot:default="props">
         <pb-body page-title="">
            <template slot="body">
               <div class="row justify-content-center">
                  <div class="col-sm-2">
                     <b-card title="Login" class="mt-5">
                        <LoginForm></LoginForm>
                     </b-card>
                  </div>
               </div>
            </template>
         </pb-body>
      </template>
   </pb-body-base>
</template>

<script>
import LoginForm from "@client/src/viewsShop/components/LoginForm";

export default {
   name: 'login',
   components: {LoginForm},
   props: {},
   data() {
      return {
         breadcrumbs: [{
            text: "Login",
            href: '/login'
         }],
         busy: false
      };
   },
}
</script>